export default __webpack_public_path__ + "static/media/img_10.3afe72bd.jpg";